import { render, staticRenderFns } from "./brands-edit-modal.vue?vue&type=template&id=dae9dea2&scoped=true"
import script from "./brands-edit-modal.vue?vue&type=script&lang=js"
export * from "./brands-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./brands-edit-modal.vue?vue&type=style&index=0&id=dae9dea2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae9dea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dae9dea2')) {
      api.createRecord('dae9dea2', component.options)
    } else {
      api.reload('dae9dea2', component.options)
    }
    module.hot.accept("./brands-edit-modal.vue?vue&type=template&id=dae9dea2&scoped=true", function () {
      api.rerender('dae9dea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/entitites-lists-with-search/brands-edit-modal.vue"
export default component.exports